// extracted by mini-css-extract-plugin
module.exports = {"large-logo":"HeaderSidebarWrapper_large-logo__28DGf"};